export class CookieService {
    static setCookie(name: string, val: string, numDays: number): void {
        const date = new Date();
        date.setTime(date.getTime() + (numDays * 24 * 60 * 60 * 1000));
        document.cookie = `${name}=${val}; expires=${date.toUTCString()}; path=/`;
    }

    static getCookie(name: string): string {
        const value = '; ' + document.cookie;
        const parts = value.split('; ' + name + '=');

        if (parts.length === 2) {
            return parts.pop().split(';').shift();
        }
    }

    static deleteCookie(name: string): void {
        const date = new Date();
        // Set it expire in -1 days
        date.setTime(date.getTime() + (-1 * 24 * 60 * 60 * 1000));
        document.cookie = `${name}=; expires=${date.toUTCString()}; path=/`;
    }

    static getAllCookies(): Record<string, string> {
        return Object.fromEntries(
            document.cookie
                .split(';')
                .map(cookieString => {
                    const [name, ...valueParts] = cookieString.trim().split('=');
                    const value = valueParts.join('=');
                    return [name, decodeURIComponent(value || '')];
                })
                .filter(([name]) => name)
        );
    }
}
